import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { Flag, FlagProps } from './Flag';
import { Select } from './Select';

import { LocalizationContext } from '../../../../src/packages/kakapo-ui-application/contexts/LocalizationScope';
import * as graphql from '../../../../src/generated/graphql';
import { useWorkspace } from 'packages/kakapo-ui-services/hooks/useWorkspace';

export function LanguageSelect(props: { value: string; onChange: (value: string) => void }) {
	const { id } = useWorkspace();
	const { t } = useTranslation();
	const [fetch, query] = graphql.useSupportedLanguagesInWorkspaceLazyQuery({
		variables: { workspaceID: id },
	});

	const languageID = props.value as FlagProps['languageID'];

	return (
		<Select
			tint={false}
			search={false}
			selectedValue={languageID}
			selectedOption={{
				icon: <Flag languageID={languageID} />,
				title: t('common.languages.' + languageID),
				value: languageID,
			}}
			options={query.data?.workspace.supportedLanguageIDs.map(
				(languageID: FlagProps['languageID']) => ({
					icon: <Flag languageID={languageID} />,
					title: t('common.languages.' + languageID),
					value: languageID,
				}),
			)}
			onChange={(value) => props.onChange(value!)}
			fetch={fetch}
		/>
	);
}

function LanguageSelectScope() {
	const context = useContext(LocalizationContext);
	return <LanguageSelect value={context.languageID} onChange={context.setLanguageID} />;
}

LanguageSelect.Scope = LanguageSelectScope;
